import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Card } from '@/components/ui/card';
import { ColumnChart, MAIN_CHART_HEIGHT } from '@/features/dashboard-charts';
import { getMetricLabel } from '@/features/dashboard-filters';
import { getExportOptions } from '@/features/chart-export/model/utils';
import type { ChartData } from '@/entities/dashboard';

import { applyServiceUserColors } from '../../lib';

interface ActivityChartProps {
  data?: ChartData;
  /** The Display filter's metric, which titles the y axis. */
  metric?: string;
  isLoading: boolean;
}

export function ActivityChart({ data, metric, isLoading }: ActivityChartProps) {
  const { t } = useTranslation();
  const exportOptions = useMemo(() => getExportOptions('service-users'), []);
  const chart = useMemo(
    () =>
      data && {
        ...applyServiceUserColors(data),
        title: '',
        metricLabel: getMetricLabel(t, metric)
      },
    [data, t, metric]
  );

  return (
    <Card className="p-4">
      <ColumnChart
        data={chart}
        height={MAIN_CHART_HEIGHT}
        loading={isLoading}
        showExport
        exportOptions={exportOptions}
      />
    </Card>
  );
}
